import { useEffect } from "react";

// Freezes background page scroll while an overlay/modal is open so the app
// shell stays rigid (no desktop-style wiggle on mobile).
export function useBodyScrollLock(active) {
  useEffect(() => {
    if (!active) return;
    const prevBody = document.body.style.overflow;
    const prevHtml = document.documentElement.style.overflow;
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevBody;
      document.documentElement.style.overflow = prevHtml;
    };
  }, [active]);
}
